import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export default function UbiWithdrawBottomSheetEu() {
  const {t} = useInferableTranslation();

  return (
    <div
      className="bottom_sheet"
      role="dialog"
      aria-modal="true"
      aria-labelledby="bottomSheetTitle"
      aria-describedby="bottomSheetDesc"
    >
      <div className="bottom_sheet_header">
        <h2
          id="bottomSheetTitle"
          className="bottom_sheet_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('msg_ubi_withdraw_title_eu')}
        </h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label="close"
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div
          className="bottom_sheet_contents"
          id="bottomSheetDesc"
        >
          <strong className="bottom_sheet_title_sub">{t('msg_ubi_withdraw_content_eu')}</strong>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_vertical">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose(true)}
          >
            {t('ctn_ubi_withdraw_proceed_eu')}
          </button>

          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose(false)}
          >
            {t('ctn_ubi_withdraw_back_eu')}
          </button>
        </div>
      </div>
    </div>
  );
}
